import React from "react";
import { Text, View, Document } from "@react-pdf/renderer";
import PageLayout from "./PageLayout";

export default function LoanRequestFormPdf({ data }) {
  const points = [
    `I request the Company to grant me an loan / advance amount of ${data?.loan_advance} for my basic / personal expenses.`,
    `I understand & authorize the Company to deduct the loan / advance from my upcoming month salaries in ${data?.loan_advance_installment} equal installments. `,
    "I acknowledge that I will not hold the Company liable for any deductions in my salary for the mentioned loan / advance amount.",
    "I also acknowledge that the Company is authorized to take any legal action for the recovery of the loan / advance amount and the expenses for the same will borne by me.",
  ];
  return (
    <Document style={{ fontSize: "12px" }}>
      <PageLayout pageNo={1} company={data?.project?.company}>
        <Text
          style={{
            fontFamily: "Helvetica-Bold",
            fontSize: 15,
            textDecoration: "underline",
            marginBottom: 30,
            textAlign: "center",
          }}
        >
          LOAN / ADVANCE REQUEST FORM
        </Text>
        <View style={{ marginBottom: 70 }}>
          <Text style={{ textAlign: "right", marginBottom: 30 }}>
            Date : {data?.arrival_date}
          </Text>
          <Text style={{ marginBottom: 15 }}>
            I, Mr. {data?.name} {data?.candidate_id} , bearing{" "}
            {data?.nationality?.name} Passport Number {data?.passport_number}{" "}
            and hereby state that.
          </Text>
          {points?.map((item, index) => (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                marginBottom: 8,
                paddingLeft: 2,
              }}
              key={index}
            >
              <Text
                style={{ fontFamily: "Helvetica-Bold", marginHorizontal: 4 }}
              >
                {">"}
              </Text>
              <Text>{item}</Text>
            </View>
          ))}
        </View>
        <View style={{ flexDirection: "row" }}>
          <View style={{ width: "100%" }}>
            <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 5 }}>
              RECEIVER ACKNOWLEDGEMENT
            </Text>
            <Text style={{ marginBottom: 5 }}>Employee Name: {data?.name}</Text>
            <Text style={{ marginBottom: 5 }}>
              Position: {data?.job_position?.name}
            </Text>
            <Text style={{ marginBottom: 15 }}>Employee Signature: </Text>
          </View>
          <View style={{ width: "100%" }}>
            <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 5 }}>
              PAYER
            </Text>
            <Text style={{ marginBottom: 5 }}>
              Project Name: {data?.project?.name}
            </Text>
            <Text style={{ marginBottom: 5 }}>
              Project Coordinator: {data?.project?.project_coordinator?.name}{" "}
            </Text>
            <Text style={{ marginBottom: 5 }}>
              PC Mobile Number:{" "}
              {data?.project?.project_coordinator?.user_detail?.mobile}
            </Text>
          </View>
        </View>
      </PageLayout>
    </Document>
  );
}
